import {
  Dialog,
  DialogContent,
  DialogTitle,
  Text,
  DialogActions,
  type DialogProps,
  Button,
  List,
  ListItem,
} from '@shared/components';

type WRExamineesImportErrorModalVariantProps =
  | {
      variant: 'exceedSeatNumber';
      wrExamineeCount: number;
      examEventSeat: number;
    }
  | {
      variant: 'duplicatedIdNumber';
      duplicateIdNumbers: string[];
    };

export type WRExamineesImportErrorModalProps = Pick<DialogProps, 'open' | 'onClose'> &
  WRExamineesImportErrorModalVariantProps;

export default function WRExamineesImportErrorModal(
  props: Readonly<WRExamineesImportErrorModalProps>,
) {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs'>
      <DialogTitle>นำเข้ารายชื่อไม่สำเร็จ</DialogTitle>
      <DialogContent>
        {props.variant === 'exceedSeatNumber' ? (
          <Text>
            ไม่สามารถนำเข้ารายชื่อได้ เนื่องจากจำนวนรายชื่อที่นำเข้า ({props.wrExamineeCount} คน)
            <br />
            เกินจำนวนที่นั่งที่เปิดรับ ({props.examEventSeat} ที่นั่ง)
          </Text>
        ) : (
          <>
            <Text>
              เนื่องจากพบเลขบัตรประชาชน/พาสปอร์ตซ้ำกันภายในรอบสอบนี้
              <br />
              กรุณาตรวจสอบและแก้ไขข้อมูลในระบบรับสมัครของท่าน:
            </Text>
            <List sx={{ listStyle: 'disc', p: (theme) => theme.spacing(0, 0, 0, 6) }}>
              {props.duplicateIdNumbers.map((idNumber) => (
                <ListItem
                  sx={(theme) => ({
                    display: 'list-item',
                    p: theme.spacing(0),
                    ...theme.typography.body2,
                  })}
                  key={idNumber}
                >
                  <Text>{idNumber}</Text>
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ alignItems: 'flex-end' }}>
        <Button color='primary' onClick={(event) => onClose?.(event, 'escapeKeyDown')}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
